import { Component, HostListener } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { CurrentWhiteLabelApplication } from 'src/app/utils/current-white-label-application';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-search-empty',
  templateUrl: './search-empty.component.html',
  standalone: true,
  imports: [NgIf, TranslateModule],
})
export class SearchEmptyComponent {
  readonly emailRecipient = 'app@debouwapp.nl';
  readonly subject = this.translateService.instant(
    'project.new.request.email.subject'
  );
  public isMainApp: boolean = false;
  timeout: any;
  showText: boolean = false;

  constructor(
    private translateService: TranslateService,
    currentWhiteLabelApplication: CurrentWhiteLabelApplication
  ) {
    this.isMainApp = currentWhiteLabelApplication.isMainApp();
  }

  @HostListener('window:blur', ['$event'])
  onBlur(event: any): void {
    clearTimeout(this.timeout);
  }

  sendMail() {
    window.location.href = `mailto:${
      this.emailRecipient
    }?subject=${encodeURIComponent(this.subject)}`;

    this.timeout = setTimeout(() => {
      this.showText = true;
    }, 1000);
  }
}
